import {defineStore} from 'pinia';

export const useCollectionStore = defineStore('collectionStore', {
    state: () => ({
        collection: null,
        productsByCategory: [],
        minPrice: 0,
        sizeTitles: null,
        surfaces: null,
        colors: null,
        rooms: null,
        patterns: null,
        images: [],
        loadings: {
            infoLoading: true,
            productLoading: true,
            imagesLoading: true,
        },
    }),
    actions: {
        loadImages() {
            this.loadings.imagesLoading = true

            axios.post('/axios/collection/get-images', {
                id: this.collection.id,
            }).then(response => {
                this.images = response.data
                this.loadings.imagesLoading = false
            }).catch(error => {
                this.loadings.imagesLoading = false
            })
        },
        loadInitialProducts(){
            this.loadings.productLoading = true

            axios.post('/axios/collection/get-initial-products', {
                id: this.collection.id,
            }).then(response => {
                this.productsByCategory = response.data ?? []

                this.loadings.productLoading = false
            }).catch(error => {
                this.loadings.productLoading = false
            })
        },
        getCollectionInfo() {
            this.loadings.infoLoading = true

            axios.post('/axios/collection/get-collection-info', {
                id: this.collection.id,
            }).then(response => {
                this.minPrice = response.data.minPrice ?? 0

                this.sizeTitles = Array.isArray(response.data.sizeTitles)
                    ? response.data.sizeTitles.join(', ')
                    : null
                this.surfaces = response.data.surfaces
                this.colors = response.data.colors
                this.rooms = response.data.rooms
                this.patterns = response.data.patterns

                this.loadings.infoLoading = false
            }).catch(error => {
                this.loadings.infoLoading = false
            })
        },
        loadMoreProductsByCategory(slug) {
            const category = this.productsByCategory[slug]
            if (!category) return

            const currentCount = category.products.length

            axios.post('/axios/collection/load-more-products', {
                id: this.collection.id,
                category_slug: slug,
                offset: currentCount,
            }).then(response => {
                const newProducts = response.data.products ?? []
                const total = response.data.total ?? 0

                this.productsByCategory[slug].products.push(...newProducts)
                this.productsByCategory[slug].total = total
            })
        }
    }
});
